import { createSlice } from '@reduxjs/toolkit';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    subHeader: '',
    applicationList: [],
    unfliteredAppsList: [],
    selectedRoleId: null,
  },
  reducers: {
    setApps: (state, { payload }) => {
      state.applicationList = payload;
    },
    setAllApps: (state, { payload }) => {
      state.unfliteredAppsList = payload;
    },
    setSubHeader: (state, { payload }) => {
      state.subHeader = payload;
    },
    setSelectedRoleId: (state, { payload }) => {
      state.selectedRoleId = payload;
    },
  },
});

export default dashboardSlice.reducer;

export const { setApps, setAllApps, setSelectedRoleId, setSubHeader } = dashboardSlice.actions;
